import { getBestCard } from './getBestCard.js'
import { getSingleMatch } from './getSingleMatch.js'
import { getDoubleMatch } from './getDoubleMatch.js'

function getCardToPlay(params) {
  const {
    playerHand,
    computerHand,
    sourceCard,
    goOutScore,
    handOver,
    endRound,
  } = { ...params }
  let cardToPlay = ''

  const hiddenLength = computerHand.filter(card => {
    return card.displayClass === 'hidden'
  }).length

  let handScore = compareHandValues(playerHand, computerHand)

  cardToPlay = getDoubleMatch(sourceCard, computerHand, playerHand)
  if (cardToPlay) {
    if (cardToPlay.displayClass === 'hidden' && hiddenLength === 1) {
      if (handScore > goOutScore) {
        return cardToPlay
      }
    }
    return cardToPlay
  }

  // If the player went out, get the best card unless double match was made
  if (handOver) {
    cardToPlay = getBestCard(sourceCard, computerHand, playerHand, handOver)
    return cardToPlay ? cardToPlay : ''
  }

  if (sourceCard.value > 7) {
    return
  }

  if (hiddenLength === 1) {
    if (handScore > goOutScore) {
      cardToPlay = goOutCard(sourceCard, computerHand)
      return
    }
  }

  if (endRound) {
    cardToPlay = lastCard(sourceCard, computerHand)
    return cardToPlay
  }

  cardToPlay = getSingleMatch(sourceCard, computerHand, playerHand)
  if (cardToPlay) {
    return cardToPlay
  }

  cardToPlay = getBestCard(sourceCard, computerHand, playerHand)
  if (cardToPlay) {
    return cardToPlay
  }
}

function goOutCard(sourceCard) {
  if (sourceCard.value < 7) {
    return sourceCard
  }
}

function lastCard(sourceCard, computerHand) {
  const sortedCards = computerHand.filter(card => {card.displayClass === 'visible'}).sort((a, b) => {
    return b.value - a.value
  })
  if (sourceCard.value < sortedCards[0].value) {
    return sourceCard
  }
}

function compareHandValues(playerHand, computerHand) {
  const computerHandValue = handValue(computerHand)
  const playerHandValue = handValue(playerHand)

  return playerHandValue - computerHandValue
}

function handValue(hand) {
  let hiddenValue
  const visibleCards = hand.filter(card => {
    return card.displayClass === 'visible'
  })

  const hiddenCards = hand.filter(card => {
    return card.displayClass === 'hidden'
  })

  if (hiddenCards.length > 0) {
    hiddenValue = hiddenCards.length * 7
  } else {
    hiddenValue = 0
  }

  let value = visibleCards.reduce((accumulator, card) => {
    return accumulator + card.value
  }, 0)

  value = value + hiddenValue

  return value
}

export { getCardToPlay }
